// extracted by mini-css-extract-plugin
module.exports = {"form":"LoginForm_form__10hPV","submit":"LoginForm_submit__2NsW9","actionCtn":"LoginForm_actionCtn__13j51"};